import { render, staticRenderFns } from "./FamousCommentListForm.vue?vue&type=template&id=fc4f5be8&"
import script from "./FamousCommentListForm.vue?vue&type=script&lang=js&"
export * from "./FamousCommentListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports